import React from "react";
import ButtonComp from "./ButtonComp";
import ReactHtmlParser from "react-html-parser";

const MasterAspectSection = ({
  description,
  titleSection,
  cards = [],
  bottomText,
  btnText,
  btnLink,
  btnImg,
  className = "",
}) => {
  return (
    <div className={`master-aspect-section ap-minute-count mt-5 ${className}`}>
      <div className="custom-container">
        <div className="row">

          {/* Heading */}
          {/* {titleSection && ReactHtmlParser(titleSection())} */}
          <div className="text-center"> {titleSection && titleSection()}</div>
            {/* Description */}
            {description && (
              <p className="FS18FW400 text-center mb-4" dangerouslySetInnerHTML={{ __html: description }}></p>
            )}
          {/* Cards */}
          <div className="master-cards">
            {cards.map((card, index) => (
              <div
                key={index}
                className={`master-card ${card.className || ""}`}
              >
                <h2 className="card-title">
                  <span className="top-section FS24FW500 fw-700">
                    {card.title}
                  </span>

                  {card.subTitle && (
                    <>
                      <br />
                      <span className="FS20FW500">
                        {card.subTitle}
                      </span>
                    </>
                  )}
                </h2>

                <ul className="feature-list">
                  {card.items?.map((item, i) => (
                    <li key={i} className="FS18FW400">
                     <p dangerouslySetInnerHTML={{ __html: item.title }}></p>
                     {item.description && <p>{item.description}</p>}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Bottom section */}
          <div className="text-center">
            {bottomText && (
              <p className="sub-heading">{bottomText}</p>
            )}

            {btnText && (
              <ButtonComp
                link={btnLink}
                btnText={btnText}
                img={btnImg}
              />
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default MasterAspectSection;